<template>
  <div class="wrapper stories">
    <div class="tab-options">
      <div class="filter-widget">
        <div class="search-widget">
          <div class="search-group">
            <img class="search" src="@/assets/icons/search.svg" />
            <input
              placeholder="Search"
              @keyup="searchTask"
              type="Type in to Search"
            />
          </div>
        </div>
        <div class="filter-select-widget divider">
          <filter-select v-model="view_type" :content="display_filter"
            >Display</filter-select
          >
        </div>
        <div class="filter-select-widget divider">
          <img src="@/assets/admin-icon/filter.svg" />
          <filter-select v-model="tag_filter_data" :content="tags_filter"
            >Tags</filter-select
          >
        </div>
        <div class="filter-select-widget divider">
          <img src="@/assets/admin-icon/filter.svg" />
          <filter-select v-model="sort_filter_data" :content="sort_filter"
            >Filter</filter-select
          >
        </div>
      </div>

      <button class="btn-add" @click="addNewStory()">
        <span> Add Task </span>
        <img src="@/assets/admin-icon/white-circle-plus.svg" />
      </button>
    </div>
    <vue-scroll>
      <div class="wrapper-section">
        <div
          class="column story_body"
          :class="{ relaxed: view_type == 'relaxed' }"
          v-for="(item, index) in columns"
          :key="index"
        >
          <div class="container">
            <div class="header">
              <div class="row-1">
                <div class="title">
                  {{ item.name | validate }}
                </div>
                <div class="options">
                  <!-- <button @click="addNewStory(item)" class="btn-add">+</button> -->
                </div>
              </div>
              <div class="row-2">
                <hr />
              </div>
            </div>
            <vue-scroll>
              <div
                class="body"
                @dragover.self="columnDradOver($event, index)"
                @dragenter.self="columnDradEnter($event, index)"
                @dragleave.self="columnDradLeave($event, index)"
                @drop.self="columnDradDrop($event)"
                @dragend="columnDragEnd($event)"
              >
                <div
                  v-for="(task, i) in item.tasks"
                  :key="i"
                  class="card"
                  draggable="true"
                  @dragstart="cardDradStart($event, task, index, i)"
                  @dragend="cardDragEnd"
                  @dragover="cardDradOver($event, index)"
                  @dragenter="cardDradEnter($event, index, i)"
                  @dragleave="cardDradLeave($event, index)"
                  @drop="cardDradDrop($event)"
                >
                  <div class="card-header">
                    <div class="title" @click="viewStory(task)">
                      {{ task.name | validate }}
                    </div>
                    <input
                      class="card-checkbox"
                      type="checkbox"
                      @change="makeCompletedTask($event, task)"
                    />
                    <div class="card-type">
                      <label :style="{ color: getColor(task.type) }">{{
                        task.type | validate
                      }}</label>
                      <div
                        :style="{ 'background-color': getColor(task.type) }"
                        class="type-box"
                      ></div>
                    </div>
                  </div>
                  <div class="compang-widget" @click="viewStory(task)">
                    <span class="company-name" v-if="task.account">{{
                      task.account.name | validate
                    }}</span>
                    <div
                      class="company-contact"
                      @click="viewStory(task)"
                      v-if="task.contacts.length > 0"
                    >
                      <template v-for="(contact, index) in task.contacts">
                        <span :key="index" v-if="index == 0">
                          {{ contact.first_name | validate }}
                          {{ contact.last_name | validate }}
                        </span>
                      </template>
                      <div
                        v-if="task.contacts.length > 1"
                        class="other-contact"
                      >
                        , & {{ (task.contacts.length - 1) | validate }} more
                        contacts
                      </div>
                    </div>
                  </div>
                  <div class="members" @click="viewStory(task)">
                    <div
                      class="member"
                      v-for="(member, index) in task.assignees"
                      :key="index"
                    >
                      <assingProfileToolTip :member="member">
                        <img
                          v-if="member.profile_picture"
                          :src="
                            $fullUrl(
                              'images/profiles/' + member.profile_picture
                            )
                          "
                          :class="{ override: index > 0 }"
                        />

                        <img
                          v-else
                          :class="{ override: index > 0 }"
                          src="@/assets/avatar.png"
                        />
                      </assingProfileToolTip>
                      <span v-if="task.assignees.length == 1" class="name">{{
                        (member.first_name + " " + member.last_name) | validate
                      }}</span>
                    </div>
                  </div>
                  <div class="due-date" v-if="task.due_date">
                    {{
                      moment(task.due_date).format("ddd, DD MMM YYYY")
                        | validate
                    }}
                  </div>
                </div>
                <div
                  @dragover="cardDradOver($event, index)"
                  @dragleave="cardDradLeave($event, index)"
                  @drop="cardDradDrop($event)"
                  v-if="item.on_drag_active"
                  class="drag-holder card"
                >
                  Drag card here
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
      </div>
    </vue-scroll>

    <!-- Add - Update Modal -->
    <div class="overlay" v-if="show_form">
      <div class="form-widget-modal">
        <div class="moder-header">
          <h4 v-if="!form.id">Create a new Task</h4>
          <h4 v-else>Update Task</h4>
        </div>
        <div class="modal-body">
          <div class="input-group">
            <label>Task*</label>
            <textarea
              type="text"
              v-model="form.task_name"
              class="input-form"
            ></textarea>
          </div>
          <div class="input-group">
            <label>Task type*</label>
            <TaskType v-model="form.task_type"></TaskType>
          </div>
          <div class="twin-input"></div>
          <div class="input-group">
            <div class="input-header">
              <label>Account</label>
              <div class="option">
                <input
                  v-model="form.create_account"
                  type="checkbox"
                  id="sfga"
                />
                <span for="sfga">New Account</span>
              </div>
            </div>

            <searchSelectInput
              v-if="!form.create_account"
              url="/account/search"
              :miltiple="false"
              placeholder="Search Account"
              v-model="story_account"
            >
              <template v-slot:result="{ result }">
                <span class="search-account-item">{{
                  result.name | validate
                }}</span>
              </template>
              <template v-slot:selected="{ selected }">
                <span class="selected-search-account-item">{{
                  selected.name | validate
                }}</span>
              </template>
            </searchSelectInput>
            <input
              v-else
              type="text"
              v-model="form.account_name"
              placeholder="Enter account name"
              class="input-form"
            />
          </div>
          <div
            class="input-group"
            v-if="!form.create_account && story_account.added[0]"
          >
            <label>Contact</label>
            <searchSelectInput
              :url="`/contact/search/${story_account.added[0].id}`"
              :miltiple="true"
              v-model="story_contact"
              placeholder="Search Contact"
            >
              <template v-slot:result="{ result }">
                <span class="search-contact-item"
                  >{{ result.first_name | validate }}
                  {{ result.last_name | validate }}</span
                >
              </template>
              <template v-slot:selected="{ selected }">
                <span class="selected-search-contact-item">{{
                  selected.first_name | validate
                }}</span>
              </template>
            </searchSelectInput>
          </div>
          <div v-if="form.create_account">
            <label>New Contact</label>
            <div class="twin-input">
              <div class="input-group">
                <input
                  type="text"
                  v-model="form.first_name"
                  placeholder="First name"
                  class="input-form"
                />
              </div>
              <div class="input-group">
                <input
                  type="text"
                  v-model="form.last_name"
                  placeholder="Last name"
                  class="input-form"
                />
              </div>
            </div>
            <div class="twin-input">
              <div class="input-group">
                <input
                  type="text"
                  v-model="form.phone"
                  placeholder="Phone"
                  class="input-form"
                />
              </div>
              <div class="input-group">
                <input
                  type="text"
                  v-model="form.email"
                  placeholder="Email"
                  class="input-form"
                />
              </div>
            </div>
          </div>
          <div class="twin-input">
            <div class="input-group">
              <label>Due date</label>
              <datetime
                class="input-date"
                v-model="due_date"
                type="date"
                format="yyyy-MM-dd"
                :min-datetime="moment().toISOString()"
              >
                <span
                  class="date-icon"
                  slot="after"
                  style="padding: 0px; margin-top: 3px"
                >
                  <img src="@/assets/admin-icon/calendar.svg" />
                </span>
              </datetime>
            </div>
            <div class="input-group">
              <label>Section</label>
              <input
                type="text"
                v-model="future_section_name"
                placeholder="Section"
                class="input-form"
                readonly
              />
            </div>
          </div>
          <div class="input-group">
            <label>Responsible / Assigned</label>
            <searchSelectInput
              url="/company/search/manager"
              :miltiple="true"
              type="site"
              v-model="assigned"
              placeholder="Responsible"
            >
              <template v-slot:result="{ result }">
                <span class="search-contact-item"
                  ><img
                    width="20"
                    v-if="result.profile_picture"
                    :src="$fullUrl('images/profiles/' + result.profile_picture)"
                  />
                  <img v-else width="20" src="@/assets/avatar.png" />
                  {{ result.first_name | validate }}
                  {{ result.last_name | validate }}</span
                >
              </template>
              <template v-slot:selected="{ selected }">
                <span class="selected-search-contact-item">
                  <img
                    width="20"
                    v-if="selected.profile_picture"
                    :src="
                      $fullUrl('images/profiles/' + selected.profile_picture)
                    "
                  />
                  <img v-else width="20" src="@/assets/avatar.png" />
                  {{ selected.first_name | validate }}</span
                >
              </template>
            </searchSelectInput>
          </div>
        </div>
        <div class="modal-footer">
          <c-button
            class="btn-save"
            :loading="loading_add_story"
            @click="submitStory()"
            >Save</c-button
          >
          <button class="btn-cancel" @click="show_form = false">Cancel</button>
        </div>
      </div>
    </div>

    <!-- Add - Update Modal -->
    <div class="overlay" v-if="show_section_form">
      <div class="form-widget-modal section-modal">
        <div class="moder-header">
          <h4 v-if="!section_form.id">Create a new Section</h4>
          <h4 v-else>Update Section</h4>
          <button
            class="btn-section-delete"
            v-if="section_form.id"
            @click="deleteSection(section_form.id)"
          >
            <img src="@/assets/admin-icon/trush.svg" /> Delete
          </button>
        </div>
        <div class="modal-body">
          <div class="input-group">
            <label>Section name*</label>
            <input
              v-model="section_form.section_name"
              type="text"
              class="input-form"
            />
          </div>
        </div>
        <div class="modal-footer">
          <c-button
            class="btn-save"
            :loading="section_add_loading"
            @click="submitSection()"
            >Save</c-button
          >
          <button class="btn-cancel" @click="show_section_form = false">
            Cancel
          </button>
        </div>
      </div>
    </div>

    <!-- View story-->
    <div class="overlay" v-if="show_story_form && story_item">
      <div class="form-widget-modal story-form-widget-modal">
        <div class="moder-header">
          <div class="options">
            <button class="btn-edit" @click="editStory(story_item)">
              <img src="@/assets/admin-icon/pensil.svg" /> Edit
            </button>
            <app-dialog
              title="Delete Task"
              ask="Are you sure you want to delete this task?"
              yesText="Delete"
              noText="Cancel"
              @onComfirm="deleteStory(story_item)"
            >
              <button class="btn-delete">
                <img src="@/assets/admin-icon/trush.svg" /> Delete
              </button>
            </app-dialog>
            <button class="btn-done">
              <input
                class="checkbox"
                @change="makeCompletedTask($event, story_item)"
                type="checkbox"
              />Completed
            </button>
          </div>
          <button @click="show_story_form = false" class="btn-close">
            &times;
          </button>
        </div>
        <div class="modal-body">
          <h4>{{ story_item.name | validate }}</h4>
          <h5 v-if="story_item.account">
            {{ story_item.account.name | validate }}
          </h5>
          <div
            class="company-contact"
            v-if="story_item.contacts && story_item.contacts.length"
          >
            <template v-for="(contact, index) in story_item.contacts">
              <span :key="index">
                {{ contact.first_name | validate }}
                {{ contact.last_name | validate }}
                <span v-if="index != story_item.contacts.length - 1">,</span>
              </span>
            </template>
          </div>
          <div class="members" v-if="story_item.assignees">
            <div
              class="member"
              v-for="(member, index) in story_item.assignees"
              :key="index"
            >
              <img
                v-if="member.profile_picture"
                :src="$fullUrl('images/profiles/' + member.profile_picture)"
                :class="{ override: index > 0 }"
              />
              <img
                v-else
                :class="{ override: index > 0 }"
                src="@/assets/avatar.png"
              />
              <span class="name">{{
                (member.first_name + " " + member.last_name) | validate
              }}</span>
            </div>
          </div>
          <div class="task-type">
            <div class="card-type">
              <label :style="{ color: getColor(story_item.type) }">{{
                story_item.type | validate
              }}</label>
              <div
                :style="{ 'background-color': getColor(story_item.type) }"
                class="type-box"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { eventBus } from "@/main";
export default {
  components: {},
  data: () => ({
    view_type: "relaxed",
    tag_filter_data: "",
    sort_filter_data: "",
    show_form: false,
    columns: [],
    item_hold: null,
    active_column_index: null,
    active_card_index: null,
    inactive_column_index: null,
    inactive_card_index: null,
    future_section_name: "Unscheduled",
    form: {
      id: null,
      team_id: null,
      column_id: null,
      task_name: "",
      task_type: "Task",
      account_id: null,
      contacts_id: null,
      due_date: "",
      assigned: [],
      added: [],
      removed: [],
      contacts_added: [],
      contacts_removed: [],
      create_account: false,
      // New account
      account_name: "",
      first_name: "",
      last_name: "",
      phone: "",
      email: "",
    },
    story_account: {
      added: [],
      removed: [],
    },
    story_contact: {
      added: [],
      removed: [],
    },
    assigned: {
      added: [],
      removed: [],
    },
    due_date: "",
    section_form: {
      id: null,
      section_name: "",
    },
    show_section_form: false,
    section_add_loading: false,
    loading_add_story: false,
    show_story_form: false,
    story_item: null,
    display_filter: [
      {
        value: "relaxed",
        name: "Relaxed",
      },
      {
        value: "compact",
        name: "Compact",
      },
    ],
    tags_filter: [
      {
        name: "Task",
        value: "task",
      },
      {
        name: "Follow up",
        value: "Follow up",
      },
      {
        name: "Call",
        value: "Call",
      },
      {
        name: "Mail",
        value: "Call",
      },
      {
        name: "Meeting",
        value: "Meeting",
      },
      {
        name: "Other",
        value: "Other",
      },
    ],
    sort_filter: [
      {
        value: "create_date",
        name: "Create Date",
      },
      {
        value: "name",
        name: "Name",
      },
    ],
    task_types: [
      {
        name: "Task",
        color: "#0884AF",
      },
      {
        name: "Follow up",
        color: "#1BA5A4",
      },
      {
        name: "Call",
        color: "#FFC273",
      },
      {
        name: "Mail",
        color: "#9FD076",
      },
      {
        name: "Meeting",
        color: "#ACAF5C",
      },
      {
        name: "Other",
        color: "#ED6400",
      },
    ],
  }),
  mounted() {
    let vm = this;
    // Get team data
    vm.getTask();
  },
  methods: {
    makeCompletedTask({ target }, task) {
      let vm = this;
      if (target.checked) {
        vm.$store
          .dispatch("TASK_MAKE_COMPLETED", {
            id: task.id,
            team_id: vm.form.team_id,
          })
          .then((response) => {
            vm.getTask();
            vm.$notify({
              group: "status",
              title: "Message",
              text: "Task is now marked as completed",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {});
      }
    },
    searchTask({ target }) {
      let vm = this;
      vm.$store
        .dispatch("TASK_SEARCH", {
          query: target.value,
          team_id: vm.form.team_id,
        })
        .then((response) => {
          vm.columns = response.data.map((item) => {
            eventBus.$set(item, "on_drag_active", false);
            return item;
          });
        })
        .catch((error) => {});
    },
    filterBySort(val) {
      let vm = this;
      vm.$store
        .dispatch("TASK_FILTER_BY_SORT", {
          option: val,
          team_id: vm.form.team_id,
        })
        .then((response) => {
          vm.columns = response.data.map((item) => {
            eventBus.$set(item, "on_drag_active", false);
            return item;
          });
        })
        .catch((error) => {});
    },
    filterByTag(val) {
      let vm = this;
      vm.$store
        .dispatch("TASK_FILTER_BY_TAG", {
          option: val,
          team_id: vm.form.team_id,
        })
        .then((response) => {
          vm.columns = response.data.map((item) => {
            eventBus.$set(item, "on_drag_active", false);
            return item;
          });
        })
        .catch((error) => {});
    },

    getColor(val) {
      let vm = this;
      let color = "";
      vm.task_types.forEach((item) => {
        if (item.name == val) {
          color = item.color;
        }
      });
      return color;
    },
    setImagefile(file) {
      let vm = this;
      if (file) {
        vm.form.file = file;
      }
    },
    deleteSection(id) {
      let vm = this;
      vm.$store
        .dispatch("TASK_DELETE_SECTION", {
          column_id: id,
          team_id: vm.form.team_id,
        })
        .then((response) => {
          vm.show_section_form = false;
          vm.getTask();
        })
        .catch((error) => {});
    },
    editSection(item) {
      let vm = this;
      vm.section_form.id = item.id;
      vm.section_form.section_name = item.name;
      vm.show_section_form = true;
    },
    editStory(task) {
      let vm = this;
      vm.form.id = task.id;
      vm.form.column_id = task.column_id;
      vm.form.task_name = task.name;
      vm.form.task_type = task.type;
      vm.form.account_id = task.account_id;
      vm.form.due_date = task.due_date;
      vm.form.create_account = false;
      vm.due_date = task.due_date
        ? vm.moment(task.due_date, "YYYY-MM-DD").add(1, "days").toISOString()
        : "";
      vm.form.assigned = [];
      vm.assigned = {
        added: [],
        removed: [],
      };
      vm.story_account = {
        added: [],
        removed: [],
      };
      vm.story_contact = {
        added: [],
        removed: [],
      };
      vm.added = [];
      vm.removed = [];
      task.assignees.forEach((item) => {
        vm.assigned.added.push({
          id: item.id,
          first_name: item.first_name,
          last_name: item.last_name,
          profile_picture: item.profile_picture,
          on_update: true,
        });
      });
      vm.story_account.added.push(task.account);
      task.contacts.forEach((item) => {
        eventBus.$set(item, "on_update", true);
        vm.story_contact.added.push(item);
      });
      vm.show_form = true;
      vm.show_story_form = false;
    },
    viewStory(task) {
      let vm = this;
      vm.$router.push({
        name: "task",
        params: { id: task.id },
      });
      vm.show_story_form = true;
      vm.story_item = task;
    },
    deleteStory(task) {
      let vm = this;
      vm.$store
        .dispatch("TASK_DELETE_STORY", {
          section_id: task.column_id,
          team_id: vm.form.team_id,
          task_id: task.id,
        })
        .then((response) => {
          vm.show_story_form = false;
          vm.getTask();
        })
        .catch((error) => {});
    },
    getTask() {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("TASK_GET_ALL", { team_id: vm.form.team_id })
        .then((response) => {
          vm.columns = response.data.map((item) => {
            eventBus.$set(item, "on_drag_active", false);
            return item;
          });
          vm.$store.dispatch("LOADER_CLOSE");
          if (vm.$route.params.id) {
            vm.columns.forEach((column) => {
              column.tasks.forEach((task) => {
                if (task.id == vm.$route.params.id) {
                  vm.viewStory(task);
                }
              });
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
        });
    },
    reLoadTask() {
      let vm = this;
      vm.$store
        .dispatch("TASK_GET_ALL", { team_id: vm.form.team_id })
        .then((response) => {
          vm.columns = response.data.map((item) => {
            eventBus.$set(item, "on_drag_active", false);
            return item;
          });
        })
        .catch((error) => {});
    },
    submitStory() {
      let vm = this;
      if (vm.story_account.added.length > 0) {
        vm.form.account_id = vm.story_account.added[0].id;
      }

      if (vm.story_contact.added.length > 0) {
        vm.form.contacts_id = vm.story_contact.added.map((item) => {
          return item.id;
        });
      }
      vm.form.due_date = vm.due_date
        ? vm.moment(vm.due_date).format("YYYY-MM-DD")
        : "";
      if (vm.assigned.added.length > 0) {
        vm.form.assigned = vm.assigned.added.map((item) => {
          return {
            id: item.id,
            first_name: item.first_name,
            last_name: item.last_name,
            profile_picture: item.profile_picture,
          };
        });
      }
      const rules = {
        task_name: {
          run: (value) => {
            if (value.length > 0) {
              return false;
            }
            return "Task can not be empty";
          },
        },
        task_type: {
          run: (value) => {
            if (value.length > 0) {
              return false;
            }
            return "Task type can not be empty";
          },
        },
        account_id: {
          run: (value) => {
            if (vm.form.create_account) {
              if (vm.form.account_name) {
                return false;
              } else {
                return "Please enter account name";
              }
            } else {
              if (value) {
                return false;
              } else {
                return "Please select account";
              }
            }
          },
        },
        contacts_id: {
          run: (value) => {
            if (vm.form.create_account) {
              if (
                vm.form.first_name &&
                vm.form.last_name &&
                vm.form.phone &&
                vm.form.email
              ) {
                return false;
              } else {
                return "Please fill all contacts information";
              }
            } else {
              if (value) {
                return false;
              } else {
                return "Please add some contacts";
              }
            }
          },
        },
        assigned: {
          run: (value) => {
            if (value.length > 0) {
              return false;
            }
            return "Add some responsible";
          },
        },
      };
      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.loading_add_story = true;
        if (!vm.form.id) {
          vm.$store
            .dispatch("TASK_ADD_NEW_STORY", vm.form)
            .then((response) => {
              vm.loading_add_story = false;
              vm.show_form = false;
              vm.getTask();
            })
            .catch((error) => {
              vm.loading_add_story = false;
            });
        } else {
          // For assigned
          vm.form.added = vm.assigned.added
            .filter((item) => !item.on_update)
            .map((item) => {
              return {
                id: item.id,
                first_name: item.first_name,
                last_name: item.last_name,
                profile_picture: item.profile_picture,
              };
            });
          vm.form.removed = vm.assigned.removed.map((item) => {
            return item.id;
          });
          // For contacts
          vm.form.contacts_added = vm.story_contact.added
            .filter((item) => !item.on_update)
            .map((item) => {
              return item.id;
            });
          vm.form.contacts_removed = vm.story_contact.removed.map((item) => {
            return item.id;
          });

          vm.$store
            .dispatch("TASK_UPDATE_STORY", vm.form)
            .then((response) => {
              vm.loading_add_story = false;
              vm.show_form = false;
              vm.getTask();
            })
            .catch((error) => {
              vm.loading_add_story = false;
            });
        }
      }
    },
    submitSection() {
      let vm = this;
      vm.section_add_loading = true;
      if (!vm.section_form.id) {
        vm.$store
          .dispatch("TASK_ADD_NEW_SECTION", vm.section_form)
          .then((response) => {
            vm.section_add_loading = false;
            vm.show_section_form = false;
            vm.getTask();
          })
          .catch((error) => {
            vm.section_add_loading = false;
          });
      } else {
        vm.$store
          .dispatch("TASK_UPDATE_SECTION", vm.section_form)
          .then((response) => {
            vm.section_add_loading = false;
            vm.show_section_form = false;
            vm.getTask();
          })
          .catch((error) => {
            vm.section_add_loading = false;
          });
      }
    },
    addNewStory() {
      let vm = this;
      vm.show_form = true;
      vm.form.assigned = [];
      vm.assigned = {
        added: [],
        removed: [],
      };
      vm.story_account = {
        added: [],
        removed: [],
      };
      vm.story_contact = {
        added: [],
        removed: [],
      };
      vm.added = [];
      vm.removed = [];
      vm.form = {
        id: null,
        column_id: null,
        team_id: vm.form.team_id,
        task_name: "",
        task_type: "Task",
        account_id: null,
        contacts_id: null,
        due_date: "",
        assigned: [],
        added: [],
        removed: [],
        contacts_added: [],
        contacts_removed: [],
        create_account: false,
        // New account
        account_name: "",
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
      };
    },
    addSectionNew() {
      let vm = this;
      vm.show_section_form = true;
      vm.section_form = {
        id: null,
        team_id: vm.form.team_id,
        section_name: "",
      };
    },
    cardDragEnd({ target }) {
      let vm = this;
      target.className = " card";
      vm.columns.forEach((item) => {
        item.on_drag_active = false;
      });
    },
    cardDradStart(e, item, column_index, card_index) {
      let vm = this;
      vm.item_hold = item;
      vm.inactive_column_index = column_index;
      vm.inactive_card_index = card_index;
      e.target.className += " hold";
      setTimeout(() => {
        e.target.className += " invisible";
      }, 0);
    },
    columnDradOver(e, index) {
      let vm = this;
      e.preventDefault();
      vm.columns.forEach((item) => {
        item.on_drag_active = false;
      });
      vm.columns[index].on_drag_active = true;
    },
    columnDradEnter(e, index) {
      e.preventDefault();
      e.target.className += " hovered";
      let vm = this;
      vm.active_column_index = index;
    },
    columnDradLeave(e, index) {
      e.target.className = "body";
      let vm = this;
    },
    columnDradDrop(e) {
      let vm = this;
      e.target.className = "body";
      if (vm.active_column_index != null) {
        vm.columns[vm.active_column_index].tasks.push(vm.item_hold);
        vm.columns[vm.inactive_column_index].tasks.splice(
          vm.inactive_card_index,
          1
        );
        let card_index = vm.columns[vm.active_column_index].tasks.length - 1;
        vm.cardMove(card_index, vm.active_column_index);
      }
    },
    columnDragEnd(e) {
      let vm = this;
    },
    cardDradOver(e, index) {
      e.preventDefault();
      let vm = this;
      vm.columns.forEach((item) => {
        item.on_drag_active = false;
      });
      vm.columns[index].on_drag_active = true;
    },
    cardDradEnter(e, column_index, card_index) {
      e.preventDefault();
      let vm = this;
      vm.active_column_index = column_index;
      vm.active_card_index = card_index;
    },
    cardDradLeave(e, column_index) {
      let vm = this;
    },
    cardDradDrop(e) {
      let vm = this;
      vm.columns.forEach((item) => {
        item.on_drag_active = false;
      });
      if (vm.active_card_index != null) {
        vm.columns[vm.inactive_column_index].tasks.splice(
          vm.inactive_card_index,
          1
        );
        vm.columns[vm.active_column_index].tasks.splice(
          vm.active_card_index,
          0,
          vm.item_hold
        );
        vm.cardMove(vm.active_card_index, vm.active_column_index);
      }
    },
    cardMove(card_index, column_index) {
      let vm = this;
      let section_id = vm.columns[column_index].id;
      let story_id = vm.columns[column_index].tasks[card_index].id;
      vm.$store
        .dispatch("TASK_MOVE_STORY", {
          to_section_id: section_id,
          story_id: story_id,
          story_index: card_index,
        })
        .then((response) => {
          vm.show_story_form = false;
          vm.reLoadTask();
        })
        .catch((error) => {});
    },
    getSectionId(name) {
      let vm = this;
      let id = null;
      vm.columns.forEach((item) => {
        if (item.name == name) {
          id = item.id;
        }
      });
      return id;
    },
  },
  watch: {
    due_date(date) {
      let vm = this;
      var user_date = vm.moment(
        vm.moment(date).format("YYYY-MM-DD"),
        "YYYY-MM-DD"
      );
      var today = vm.moment(vm.moment().format("YYYY-MM-DD"), "YYYY-MM-DD");
      var number_days = user_date.diff(today, "days");
      console.log(number_days);
      var date_end_next_month = vm.moment().add(1, "months").endOf("month");
      var next_month_number_days = date_end_next_month.diff(today, "days");

      var date_end_next_six_month = vm.moment().add(6, "months").endOf("month");
      var next_six_month_number_days = date_end_next_six_month.diff(
        today,
        "days"
      );

      if (number_days == 0) {
        vm.future_section_name = "Today";
      } else if (number_days == 1) {
        vm.future_section_name = "Tomorrow";
      } else if (number_days <= 10) {
        vm.future_section_name = "Next 10 days";
      } else if (number_days > 10 && number_days < next_month_number_days) {
        vm.future_section_name = "Next Month";
      } else if (number_days <= next_six_month_number_days) {
        vm.future_section_name = "Next 6 Months";
      } else {
        vm.future_section_name = "Unscheduled";
      }
      vm.form.column_id = vm.getSectionId(vm.future_section_name);
    },
    tag_filter_data(val) {
      let vm = this;
      vm.filterByTag(val);
    },
    sort_filter_data(val) {
      let vm = this;
      vm.filterBySort(val);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding-top: 6px;
  padding-bottom: 6px;
  .section-options {
    position: fixed;
    top: 109px;
    right: 0px;
    padding: 0px 20px;
    .btn-add-section {
      background: #035767;
      color: #fff;
      padding: 8px 12px;
      border-radius: 15px;
      width: 121px;
      margin-left: 14px;
    }
  }
  .wrapper-section {
    height: 100%;
    display: flex;
    align-items: flex-start;
    overflow-x: auto;
    justify-content: flex-start;
    overflow-y: hidden;
    padding-left: 6px;
    padding-top: 6px;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none;
    }
    .column {
      width: 125px;
      margin-right: 6px;
      border-radius: 5px;
      height: 100%;
      transition: 600ms ease-in-out;
      &.relaxed {
        width: 250px;
        * {
          transition: 600ms ease-in-out;
        }
        .container {
          height: calc(100vh - 130px);
          display: flex;
          flex-direction: column;
          .header {
            width: 100%;
            background: #fff;
            .row-1 {
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 50px;
              width: 100%;
              padding: 10px 0px;
              .title {
                text-transform: capitalize;
                font-size: 15px;
                font-weight: 800;
                overflow: hidden;
                text-decoration: none;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 100%;
              }
              .options {
                .btn-add {
                  background: linear-gradient(180deg, #229fa5 0%, #229ea5 100%);
                  color: #fff;
                  border-radius: 5px;
                  padding-top: 3px;
                  width: 35px;
                  height: 35px;
                  margin-left: 14px;
                  font-size: 20px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                }
              }
            }
          }
          .body {
            width: 100%;
            max-height: calc(100% - 50px);
            min-height: 100px;
            overflow-y: auto;
            padding: 10px 6px;
            -ms-overflow-style: none; /* IE and Edge */
            scrollbar-width: none; /* Firefox */
            background: #fff;
            border-bottom-right-radius: 10px;
            border-bottom-left-radius: 10px;
            &::-webkit-scrollbar {
              display: none;
            }
            .card {
              width: 100%;
              background: #f5f5f5;
              position: relative;
              padding: 15px 15px;
              cursor: pointer;
              border-radius: 5px;
              margin-bottom: 5px;
              .card-header {
                display: flex;
                justify-content: space-between;
                margin-bottom: 5px;
                width: 100%;
                .title {
                  font-size: 14px;
                  font-family: "AvenirRoman";
                  font-weight: 800;
                  color: #000;
                  overflow: hidden;
                  text-decoration: none;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 100%;
                }
                .card-type {
                  display: flex;
                  align-items: center;
                  label {
                    font-size: 10px;
                  }
                  .type-box {
                    height: 15px;
                    width: 15px;
                    border-radius: 2px;
                    margin-left: 5px;
                  }
                }
              }
              .compang-widget {
                display: flex;
                flex-direction: column;
                padding-right: 20px;
                .company-name {
                  color: #707070;
                  font-size: 12px;
                  margin-bottom: 5px;
                }
                .company-contact {
                  display: flex;
                  align-items: center;
                  margin-bottom: 5px;
                  span {
                    font-size: 12px;
                  }
                  .other-contact {
                    color: #ccc;
                    font-size: 12px;
                  }
                }
              }
              .members {
                display: flex;
                .member {
                  display: flex;
                  align-items: center;
                  img {
                    width: 20px;
                    height: 20px;
                    object-fit: cover;
                    margin-right: 4px;
                    border-radius: 50%;
                    border: 2px solid #fff;
                    &.override {
                      margin-left: -10px;
                    }
                  }
                  .name {
                    background: #06a1a11f;
                    padding: 2px 5px;
                    border-radius: 15px;
                    font-size: 11px;
                    color: #04a5a5;
                    display: block;
                  }
                }
              }
              .due-date {
                position: absolute;
                bottom: 18px;
                right: 15px;
                font-size: 10px;
                display: block;
              }
              &.hold {
                border: solid#04a5a5 1px;
                border-radius: 5px;
              }
              &.invisible {
                opacity: 0.5;
              }
            }

            &.hovered {
              background: #f4f4f4;
            }
          }
        }
      }
      .container {
        height: calc(100vh - 130px);
        display: flex;
        flex-direction: column;
        .header {
          width: 100%;
          background: #fff;
          padding: 0px 10px;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          .row-1 {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 50px;
            width: 100%;
            padding: 10px 0px;

            .title {
              text-transform: capitalize;
              font-size: 14px;
              font-weight: 800;
              overflow: hidden;
              text-decoration: none;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 100%;
              margin-top: 9px;
            }
            .options {
              .btn-add {
                background: linear-gradient(180deg, #229fa5 0%, #229ea5 100%);
                color: #fff;
                border-radius: 5px;
                padding-top: 3px;
                width: 35px;
                height: 35px;
                margin-left: 14px;
                font-size: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
          }
          .row-2 {
            hr {
              height: 2px;
              background: #ddd;
              border: none;
            }
          }
        }
        .body {
          width: 100%;
          max-height: calc(100% - 50px);
          min-height: 100px;
          overflow: hidden;
          padding: 10px 6px;
          -ms-overflow-style: none; /* IE and Edge */
          scrollbar-width: none; /* Firefox */
          background: #fff;
          border-bottom-right-radius: 10px;
          border-bottom-left-radius: 10px;
          &::-webkit-scrollbar {
            display: none;
          }
          .card {
            width: 100%;
            background: #f5f5f5;
            position: relative;
            padding: 15px 15px;
            cursor: pointer;
            border-radius: 5px;
            margin-bottom: 5px;
            &:hover {
              .card-header {
                .card-type {
                  display: none;
                }
                .card-checkbox {
                  display: block;
                }
              }
            }
            .card-header {
              display: flex;
              justify-content: space-between;
              margin-bottom: 5px;
              width: 100%;
              .title {
                font-size: 14px;
                font-family: "AvenirRoman";
                font-weight: 800;
                color: #000;
                overflow: hidden;
                text-decoration: none;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 100%;
              }
              .card-checkbox {
                display: none;
              }
              .card-type {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                label {
                  font-size: 10px;
                  white-space: nowrap;
                  text-align: right;
                }
                .type-box {
                  height: 15px;
                  width: 15px;
                  border-radius: 2px;
                  margin-left: 5px;
                }
              }
            }
            .compang-widget {
              display: flex;
              flex-direction: column;
              padding-right: 20px;
              .company-name {
                color: #707070;
                font-size: 12px;
                margin-bottom: 5px;
              }
              .company-contact {
                display: flex;
                align-items: center;
                margin-bottom: 5px;
                span {
                  font-size: 12px;
                  white-space: nowrap;
                }
                .other-contact {
                  color: #ccc;
                  font-size: 12px;
                  white-space: nowrap;
                }
              }
            }
            .members {
              display: flex;
              .member {
                display: flex;
                align-items: center;
                img {
                  width: 20px;
                  height: 20px;
                  object-fit: cover;
                  margin-right: 4px;
                  border-radius: 50%;
                  border: 2px solid #fff;
                  &.override {
                    margin-left: -10px;
                  }
                }
                .name {
                  background: #06a1a11f;
                  padding: 2px 5px;
                  border-radius: 15px;
                  font-size: 11px;
                  color: #04a5a5;
                  display: block;
                  overflow: hidden;
                  text-decoration: none;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 68px;
                  text-transform: capitalize;
                }
              }
            }
            .due-date {
              position: absolute;
              bottom: 18px;
              right: 15px;
              font-size: 10px;
              display: none;
            }
            &.hold {
              border: solid#04a5a5 1px;
              border-radius: 5px;
            }
            &.invisible {
              opacity: 0.5;
            }
          }
          .drag-holder {
            height: 80px;
            width: 100%;
            border: 1px dashed rgb(75, 75, 75);
            display: flex;
            align-items: center;
            justify-content: center;
          }
          &.hovered {
            background: #f4f4f4;
          }
        }
      }
    }
  }

  .form-widget-modal {
    width: 500px;
    position: relative;
    .input-group {
      position: relative;
      .task-search-reasult {
        position: absolute;
        height: 200px;
        overflow-y: auto;
        z-index: 9999;
        background: #fff;
        box-shadow: 0px 0px 10px #a8a8a8;
        width: 100%;
        top: 62px;
        .task-item {
          display: flex;
          align-items: center;
          margin-bottom: 5px;
          padding: 5px 10px;
          cursor: pointer;
          &:hover {
            background: rgb(241, 241, 241);
          }
          img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 10px;
          }
        }
      }
    }
  }
  .section-modal {
    .moder-header {
      display: flex;
      justify-content: space-between;
      .btn-section-delete {
        display: flex;
        align-items: center;
        img {
          width: 12px;
          margin-right: 3px;
          margin-top: -2px;
        }
      }
    }
  }
  .story-form-widget-modal {
    width: 500px;
    min-height: 200px;
    padding: 0px;
    .moder-header {
      display: flex;
      justify-content: space-between;
      position: relative;
      padding: 10px 10px;
      padding-bottom: 0px;
      margin-bottom: 0px;
      border-bottom: 1px solid #ddd;
      .options {
        display: flex;
        align-items: center;
        button {
          display: flex;
          align-items: center;
          margin-right: 10px;
          font-size: 13px;
          img {
            width: 15px;
            margin-right: 4px;
            margin-top: -4px;
          }
          .checkbox {
            margin-right: 4px;
            margin-top: -4px;
          }
        }
      }
      .btn-close {
        font-size: 30px;
        color: #890000;
      }
    }
    .modal-body {
      padding: 0px 20px;
      padding-top: 20px;
      padding-bottom: 20px;
      h4,
      h5,
      h6,
      p {
        margin: 0px;
      }
      h4 {
        font-size: 14px;
        color: #000;
        margin-bottom: 21px;
        padding-bottom: 20px;
        border-bottom: 1px solid #ddd;
      }
      h5 {
        font-size: 17px;
        color: #707070;
        margin-bottom: 21px;
        padding-bottom: 20px;
        border-bottom: 1px solid #ddd;
      }

      .company-contact {
        margin-bottom: 15px;
        padding-bottom: 20px;
        border-bottom: 1px solid #ddd;
      }
      h6 {
        font-size: 15px;
        color: #000;
        margin-bottom: 4px;
      }
      p {
        font-size: 15px;
        font-weight: 800;
        color: #707070;
        margin-bottom: 4px;
      }
      .members {
        display: flex;
        flex-direction: column;
        max-height: 150px;
        overflow-y: auto;
        position: relative;
        bottom: -10px;
        .member {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          img {
            width: 23px;
            margin-right: 10px;
            border-radius: 50%;
          }
        }
      }
      .task-type {
        position: absolute;
        right: 27px;
        bottom: 23px;
        .card-type {
          display: flex;
          align-items: center;
          .type-box {
            height: 15px;
            width: 15px;
            border-radius: 2px;
            margin-left: 5px;
          }
        }
      }
    }
  }
}
.search-account-item {
  padding: 10px 15px;
  display: block;
  cursor: pointer;
  &:hover {
    background: rgb(250, 250, 250);
  }
}
.selected-search-account-item {
  padding: 5px 12px;
  display: block;
  cursor: pointer;
  border: 1px solid #ddd;
  margin-top: 10px;
  border-radius: 15px;
  font-size: 11px;
  &:hover {
    background: rgb(250, 250, 250);
  }
}
.search-contact-item {
  padding: 10px 15px;
  display: flex;
  cursor: pointer;
  align-items: center;
  img {
    border-radius: 50%;
    margin-right: 8px;
  }
  &:hover {
    background: rgb(250, 250, 250);
  }
}
.selected-search-contact-item {
  padding: 5px 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid #ddd;
  margin-top: 10px;
  border-radius: 15px;
  font-size: 11px;
  img {
    border-radius: 50%;
    margin-right: 8px;
  }
  &:hover {
    background: rgb(250, 250, 250);
  }
}
.input-date {
  background: #fff;
}
</style>
